import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./challanReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import {  useHistory } from "react-router-dom";


let excelData = [];

function PaidmrReport({ sessionObject }) {
    const history = useHistory();
    const columns = React.useMemo(
        () => [
            {
                Header: "Paid MR No",
                accessor: "paid_mr_no",
                canFilter: true,
            },
            {
                Header: "Bilty No",
                accessor: "bilty_no",
                canFilter: true,
            },
            {
                Header: "Paid MR Date",
                accessor: "created_date",
                Cell: ({ value }) => {
                    value = value.split("T");
                    return value[0];
                },
                canFilter: true,
            },
            {
                Header: "Party Name",
                accessor: "consignor_name",
                canFilter: true,
            },
            {
                Header: "Station From",
                accessor: "station_from",
                canFilter: true,
            },
            {
                Header: "Station To",
                accessor: "station_to",
                canFilter: true,
            },
            {
                Header: "Bank Name",
                accessor: "bank_name",
                canFilter: true,
            },
            {
                Header: "Cheque No",
                accessor: "cheque_no",
                canFilter: true,
            },
            {
                Header: "Add Amount",
                accessor: "add_amount",
                canFilter: true,
            },
            {
                Header: "Total Amount",
                accessor: "total_amount",
                canFilter: true,
            },
            {
                Header: "Created By",
                accessor: "created_by",
                canFilter: true,
            },
        ],
        []
    );

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const fetchIdRef = React.useRef(0);
    let download_ref = React.useRef(null);
    const sortIdRef = React.useRef(0);
    const [dateState, setDateState] = React.useState({
        date_from: new Date(),
        date_to: new Date(),
    });
    const [finalInput, setFinalInput] = React.useState({});

    const fetchData = React.useCallback(
        async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
          const fetchId = ++fetchIdRef.current;
          for (let key in customFilters) {
            if (customFilters[key].toLowerCase() == "none") {
              customFilters[key] = null;
            }
          }
          setLoading(true);
    
          if (fetchId === fetchIdRef.current) {
            let newObject = {};
            newObject.created_from = String(sessionObject.sessionVariables.branch_id);
            newObject = { ...newObject, ...customFilters };
    
            let inputData = {
              paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
              sort_fields: sortBy,
              filter_fields: newObject,
              date_dict: {
                date_from: dateObject.date_from,
                date_to: dateObject.date_to,
              },
            };
    
            setFinalInput(inputData);
    
            let response = await fetch(SERVER_URL + "/report/paid_mr_report", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(inputData),
            });
            let resp = await response.json();
    
            if (resp["data"] && "total_rows" in resp) {
              setData(resp["data"]);
              setPageCount(Math.ceil(resp["total_rows"] / pageSize));
            }
            setLoading(false);
          }
        },
        []
      );

    return (
        <div className="report-challan">
            <div className="form-header">Paid MR Report</div>

            <div className="report-challan-table-container">

                <div className="report-field-row">
                    <div>
                        From Date:{" "}
                        <DatePicker
                            dateFormat="dd-MM-yyy"
                            selected={dateState.date_from}
                            onChange={(date) =>
                                setDateState({
                                    ...dateState,
                                    ["date_from"]: date,
                                })
                            }
                        />
                    </div>
                    <div>
                        To Date:{" "}
                        <DatePicker
                            dateFormat="dd-MM-yyy"
                            selected={dateState.date_to}
                            onChange={(date) =>
                                setDateState({
                                    ...dateState,
                                    ["date_to"]: date,
                                })
                            }
                        />
                    </div>
                </div>

                <ReportTable
                    columns={columns}
                    data={data}
                    fetchData={fetchData}
                    dateObject={dateState}
                    loading={loading}
                    pageCount={pageCount}
                />
            </div>
            <div className="form-footer">
                <button style={{ display: "none" }}>
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button"
                        table="paidmr_report_excel"
                        filename="tablexls"
                        sheet="tablexls"
                        buttonText="Download as XLS"
                        ref={(a) => (download_ref.current = a)}
                    />
                </button>
                {
                <button
                    className="download-table-xls-button"
                    onClick={async () => {
                        setLoading(true);

                        let inputData = {
                            sort_fields: finalInput.sort_fields,
                            filter_fields: finalInput.filter_fields,
                            date_dict: finalInput.date_dict,
                        };

                        let response = await fetch(SERVER_URL + "/report/paid_mr_report", {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(inputData),
                        });

                        let resp = await response.json();

                        excelData = resp.data;
                        setLoading(false);
                        download_ref.current.handleDownload();
                    }}
                >
                    Download as XLS
                </button>
                }
                
                {ReportExcel.paidmr_report_excel(excelData, dateState)}
            </div>
        </div>
    );
}

export default PaidmrReport;